export default function (Alpine) {
    Alpine.directive("confirm", (el, { expression }, { cleanup }) => {
        let handler = (event) => {
            let message =
                expression === "x-confirm"
                    ? "Voulez-vous vraiment effectuer cette action ?"
                    : expression
            if (!confirm(message)) {
                event.preventDefault()
            }
        }

        el.addEventListener("click", handler)

        cleanup(() => {
            el.removeEventListener("click", handler)
        })
    })
}
